import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from './routes/interceptors/auth.interceptor';
import localeNl from '@angular/common/locales/nl';
import { LOCALE_ID } from '@angular/core';
import { DatePipe, DecimalPipe, registerLocaleData } from '@angular/common';

// Register Dutch locale
registerLocaleData(localeNl, 'nl');

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({
			eventCoalescing: true,
		}),
		provideHttpClient(withInterceptors([authInterceptor]), withFetch()),
		provideAnimations(),
		provideTranslateService({
			defaultLanguage: 'nl',
		}),
		provideRouter(
			routes,
			withComponentInputBinding(),
			withRouterConfig({
				paramsInheritanceStrategy: 'always',
			})
		),
		provideClientHydration(withEventReplay()),
		{ provide: LOCALE_ID, useValue: 'nl' },
		DecimalPipe,
		DatePipe,
	],
};
